module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_7042.b111463a.png";